<template>
    <div class="content">

        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Audience</h1>
                    <p>Gestion des campagnes</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.audience.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une audience</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxcore.audience.export')" @click="exportFile('invoices')">
                  <icon name="download-cloud-01"/>
                  <span>Export les résultats (Excel)</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <div class="campaigns" v-if="resources && resources.length">
                    <div class="datagrid" :class="paginator.listing">
                        <div class="datagrid-header">
                            <div>
                                <div></div>
                                <div></div>
                                <div>
                                  <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                                </div>
                                <div class="center">Audience</div>
                                <div>Scopes</div>
                                <div class="actions"></div>
                                <div></div>
                            </div>
                        </div>
                        <div class="datagrid-body">
                            <div v-for="item in resources" @dblclick="edit(item.id)">
                                <div></div>
                                <div class="picture">
                                    <figure>
                                        <i v-if="!item.picture" class="icon icon-icon_users"></i>
                                        <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                                    </figure>
                                </div>
                                <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p></div>
                                <div class="center"><i class="icon icon-icon_users"></i> {{ item.audience.count }}</div>
                                <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                                <div class="actions">
                                  <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.audience.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.audience.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                  </ul>
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="empty-actions" v-if="resources && resources.length == 0">
                    <div @click="create()">
                        <i class="icon icon-icon_users"></i>
                        <h3>Créer une audience</h3>
                        <p>Segmenter vos contacts,afin de les cibler par vos campagnes.</p>
                        <button><span>Créer</span></button>
                    </div>
                </div>

            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import AudienceService from './AudienceService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
              tabsFilter: []
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return AudienceService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/campaign/audience/Index.vue